import { truncate } from "neetocist";
import { Avatar, Typography } from "neetoui";

const ProfileHeader = ({ profileInfo }) => {
  const { name, email } = profileInfo;

  return (
    <span
      className="flex w-full min-w-0 items-center gap-2 text-start"
      data-testid="floating-action-menu-profile-header"
    >
      <Avatar
        data-testid="floating-action-menu-header-profile-icon"
        size="medium"
        user={profileInfo}
      />
      <span className="neeto-ui-flex neeto-ui-flex-col neeto-ui-flex-grow neeto-ui-min-w-0 gap-1">
        <Typography
          className="neeto-ui-m-0"
          component="span"
          data-testid="floating-action-menu-header-user-name"
          lineHeight="tight"
          style="h5"
          title={name}
          weight="semibold"
        >
          {truncate(name, 18)}
        </Typography>
        {email && (
          <Typography
            className="neeto-ui-w-full neeto-ui-truncate neeto-ui-text-gray-500"
            component="span"
            data-testid="floating-action-menu-header-user-email"
            lineHeight="tight"
            style="body3"
          >
            {email}
          </Typography>
        )}
      </span>
    </span>
  );
};

export default ProfileHeader;
